import React, {
    useState, useCallback, useContext, useMemo,useEffect
} from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { TranslatorContext } from '@jutro/locale';
import {
    Button,
    ModalNext,
    ModalHeader,
    ModalBody,
    ModalFooter
} from '@jutro/components';
import { ServiceManager } from '@jutro/services';
import { useValidation } from 'gw-portals-validation-react';
import { ViewModelUtil } from 'gw-portals-viewmodel-js';
import generateSubComponents from './ScheduleItemTypes/ScheduleItemTypes';
import messages from 'gw-components-platform-react/ScheduleItemsComponent/ScheduleItemsComponent.messages';
import styles from './ScheduleItemModalPopover.module.scss'

function ScheduleItemModalPopover(props) {
    const {
        propertyInfo,
        viewModelService,
        scheduleData,
        scheduleItem,
        labelPosition,
        id,
        isNew,
        isOpen,
        onResolve,
        onReject,
        bodyAutoFocus
    } = props;
    const translator = useContext(TranslatorContext);
    const localeService = ServiceManager.getService('locale-service');
    const [modalData, setModalData] = useState(scheduleData);
    const { isComponentValid, onValidate } = useValidation(id);
    const [cPersItemSchItemType, setCPersItemSchItemType] = useState([]);

    const map = new Map();
    map.set('HOP_PersonalItemsSchItemsFineArts_EY', ['ItemTypeNonPro_EY','HOP_ItemTypeProfeComm_EY']);
    map.set('HOP_PersonalItemsSchItemsCameraEquip_EY', ['ItemTypeNonPro_EY','HOP_ItemTypeProfeComm_EY']);
    map.set('HOP_PersonalItemsSchItemsMusicalInstr_EY', ['ItemTypeNonPro_EY','HOP_ItemTypeProfeComm_EY']);
    map.set('HOP_PersonalItemsSchItemsTools_EY', ['HOP_ItemTypeHobbyist_EY','HOP_ItemTypeProfeComm_EY']);
    map.set('HOP_PersonalItemsSchItemsPsnlComputer_EY', ['HOP_ItemTypeSoftware_EY','HOP_ItemTypeDsktpAndAccessories_EY']);

    const modalOverrides = {
        '@field': {
            labelPosition,
            showOptional: true,
            showRequired:true
        }
    };

    useEffect(() => {
        if(scheduleItem.patternName ==='HOP_PersonalItemsSchItems_EY') {
        const clonedData = _.clone(propertyInfo);
        const persItemSchItemType_EY = clonedData.filter(id => id.id==='PersItemSchItemType_EY').flatMap(i =>i.availableTypeListValues);
        setCPersItemSchItemType(persItemSchItemType_EY)
        }
    },[])

    const handleChange = useCallback(
        (value, path) => {
            const clonedData = _.cloneDeep(modalData);
            const newPath = ViewModelUtil.getNonVMPath(path);
            _.set(clonedData, newPath, value);
            setModalData(clonedData);
        },
        [modalData]
    );

    const orderedPropertyInfo = useMemo(() => _.sortBy(propertyInfo, 'order'), [propertyInfo]);
    const defaultCountryCode = localeService.getDefaultCountryCode();
    
    //~ HOP_PersonalItemsSchItems_EY filter logic ====================================================
    const updatedOrderedPropertyInfo = useMemo(() => {
        if(scheduleItem.patternName ==='HOP_PersonalItemsSchItems_EY') {
            const codeValue =  _.get(modalData,'itemData.HOP_PersItemsItem_EY.typeCodeValue')
            if(codeValue) {
                let definedValues = map.get(codeValue)
                definedValues =  definedValues? [...definedValues] :['HOP_ItemTypeNone_EY'];
                const items = orderedPropertyInfo.filter(ops => ops.id ==='PersItemSchItemType_EY');
                items.forEach( (item) => {
                   const values =  item.availableTypeListValues.filter(f => definedValues.includes(f.code)) 
                   item.filteredAvailableTypeListValues = values;
                })
            }

        }

        return orderedPropertyInfo;
    }, [modalData])

    const subComponents = updatedOrderedPropertyInfo.flatMap((info) => generateSubComponents({
        info,
        modalData,
        viewModelService,
        translator,
        defaultCountryCode,
        scheduleItem,
        onValueChange: handleChange,
        onValidate,
        parentOverrides: modalOverrides,
        isNew
    }));

    const handleAdd = useCallback(() => {
        onResolve(modalData);
    }, [onResolve, modalData]);

    const modalOkLabel = useMemo(() => {
        return isNew ? messages.scheduleAdd : messages.save;
    }, [isNew]);

    return (
        <ModalNext
            className={styles.scheduleItemModal}
            isOpen={isOpen}
        >
            <ModalHeader
                title={scheduleItem.displayName}
            />
            <ModalBody
                contentLayout={{
                    component: 'grid'
                }}
                autoFocus={bodyAutoFocus}
            >
                {subComponents}
            </ModalBody>
            <ModalFooter>
                <Button onClick={onReject} type="secondary">
                    {messages.scheduleCancel}
                </Button>
                <Button onClick={handleAdd} disabled={!isComponentValid}>
                    {modalOkLabel}
                </Button>
            </ModalFooter>
        </ModalNext>
    );
}

ScheduleItemModalPopover.propTypes = {
    propertyInfo: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    scheduleData: PropTypes.shape({}),
    labelPosition: PropTypes.string,
    id: PropTypes.string.isRequired,
    isOpen: PropTypes.string.isRequired,
    onResolve: PropTypes.func,
    scheduleItem: PropTypes.shape({
        displayName: PropTypes.string
    }).isRequired,
    viewModelService: PropTypes.shape({}).isRequired,
    isNew: PropTypes.bool.isRequired,
    bodyAutoFocus: PropTypes.string.isRequired,
    onReject: PropTypes.func.isRequired
};
ScheduleItemModalPopover.defaultProps = {
    scheduleData: {},
    labelPosition: 'left',
    onResolve: undefined
};
export default ScheduleItemModalPopover;
